<template>
    <div>
        <MercenaryHeader :title="'유소년 가족 인증'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; padding:12px; background-color: #f5f5f5;">
            <div style="color:#210F03; font-size: 16px; font-weight:500; margin-top:20px;">상태</div>
            <div class="container" style="margin-top:8px;">
                <div>
                    <div class="label">인증 상태</div>
                    <div v-if="member_family.nic_name && age < 19" class="contents">인증 완료</div>
                    <div v-else-if="age < 19" class="contents">인증 안됨</div>
                    <div v-else class="contents">유소년 회원이 아닙니다.</div>
                </div>
            </div>

            <template v-if="age < 19 && member_family.nic_name">
                <div class="container" style="margin-top:8px;">
                    <div>
                        <div class="label">인증 날짜</div>
                        <div class="contents">{{member_family.insert_date | dotDate}}</div>
                    </div>
                </div>

                <div style="color:#210F03; font-size: 16px; font-weight:500; margin-top:20px;">가족 정보</div>
                <div class="container" style="margin-top:8px;">
                    <div>
                        <div class="label">부모/법정대리인 이름</div>
                        <div class="contents">{{member_family.nic_name}}</div>
                    </div>
                </div>
                <div class="container" style="margin-top:8px;">
                    <div>
                        <div class="label">연락처</div>
                        <div class="contents">{{member_family.phone}}</div>
                    </div>
                </div>

                <div class="container" @click="() => { }">
                    <div>
                        <div class="label">인증관리</div>
                        <div class="contents">기존 가족 정보를 삭제하고 다시 등록할 수 있습니다</div>
                    </div>
                    <div class="horizontal_line" style=""></div>
                    <div style="font-size:14px; font-weight:500; color:var(--color-main)" @click="deleteFamily" >가족 정보 삭제하기</div>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import moment from 'moment';
    import ResponseCode from "../../../ResponseCode";

    export default {
        name: "YouthFamilyAuth",
        components: {MercenaryHeader},
        data(){
            return {
                member_family : {},
            }
        },
        computed : {
            age(){
                return this.getYears();
            }
        },
        methods : {
            async getFamily(){
                const res = await this.$Axios.get('/api/member/family/mine');
                if(res.data.member_family.length > 0){
                    this.member_family = res.data.member_family[0];
                }else {
                    this.member_family = {};
                }
            },
            getYears(){
                const start_date = this.$GlobalStore.loginInfo().birthday;
                const end_date = moment().format('YYYY-MM-DD');

                const yearsDiff = moment(end_date, "YYYY-MM-DD").diff(moment(start_date, "YYYY-MM-DD"), 'years');
                return yearsDiff;
            },
            async deleteFamily(){
                if(!confirm('정말로 가족 정보를 삭제하시겠습니까?')){
                    return;
                }

                const res = await this.$Axios.post('/api/member/family/delete');
                if(res.data.code === ResponseCode.SUCCESS){
                    this.getFamily();
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.closeLastModal();
                }
            }
        },
        created(){
            this.deleteFamily = this.$Once(this.deleteFamily);

            this.getFamily();
        }
    }
</script>

<style scoped>

    .container {
        background-color: white;
        border-radius: 12px;
        padding: 12px;
    }

    .label {
        font-size: 14px;
        font-weight: bold;
        color: #210F03
    }

    .contents {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #210F03;
    }

    .container+.container {
        margin-top: 10px;
    }


    .horizontal_line {
        height: 1px;
        background-color: #EBEBEB;
        margin: 12px 0px;
    }
</style>